var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2202 63.6838L28.5816 59.8136L26.7294 61.6659C24.1543 57.7355 22.6485 53.0522 22.6485 47.9925C22.6485 47.0438 22.7087 46.1101 22.7991 45.1915L12.9506 53.3534L1.85223 44.1675C1.74682 45.4325 1.68658 46.6974 1.68658 47.9925C1.68658 58.8348 5.45129 68.7887 11.7459 76.6494L10.2551 78.1402L12.7849 77.8993L27.0005 76.5591L28.2202 63.6838Z",
    fill: "url(#paint0_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8141 45.1915L25.9162 42.6165H23.2358C24.5158 36.7887 27.8287 31.7289 32.4066 28.2202L19.4259 27.0005L18.1007 12.8452C9.36659 20.1788 3.40329 30.6899 2.01788 42.6165H0L1.85223 44.1525L12.9506 53.3384L22.8141 45.1915Z",
    fill: "url(#paint1_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4066 28.2353L36.1713 28.5816L34.4244 26.8348C38.2343 24.4706 42.7369 23.1002 47.5557 23.1002C48.8207 23.1002 50.0555 23.1906 51.2602 23.3713L42.6315 12.9506L51.456 2.304C50.176 2.19859 48.8659 2.13836 47.5557 2.13836C36.9393 2.13836 27.1661 5.75247 19.3957 11.8061L17.8597 10.2701L18.1007 12.8602L19.4259 27.0155L32.4066 28.2353Z",
    fill: "url(#paint2_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2602 23.3713L53.3685 25.9162V23.7779C59.2113 25.1784 64.2409 28.6268 67.6744 33.3252L68.9845 19.4259L82.3868 18.1609C75.1586 9.74306 64.9487 3.96047 53.3685 2.49976V0L51.456 2.304L42.6315 12.9506L51.2602 23.3713Z",
    fill: "url(#paint3_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6744 33.3252L67.4033 36.1713L68.7134 34.8612C71.0777 38.6711 72.448 43.1737 72.448 47.9925C72.448 49.2273 72.3577 50.432 72.192 51.6066L83.0344 42.6165L93.2894 51.1097C93.3647 50.0706 93.3948 49.0315 93.3948 47.9774C93.3948 37.3609 89.7807 27.5878 83.7271 19.8174L85.7148 17.8297L82.3567 18.1459L68.9544 19.4108L67.6744 33.3252Z",
    fill: "url(#paint4_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2894 51.1247L83.0344 42.6315L72.192 51.6216L70.0838 53.3685H71.8758C70.6108 59.1511 67.328 64.1807 62.7953 67.6894L76.5741 68.9845L77.8391 82.432C86.1214 75.1435 91.7534 64.9035 93.0936 53.3685H95.9849L93.2894 51.1247Z",
    fill: "url(#paint5_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7953 67.6744L59.8136 67.3882L61.2141 68.7887C57.2838 71.3638 52.6005 72.8697 47.5407 72.8697C46.6221 72.8697 45.7186 72.8245 44.8301 72.7191L53.3534 83.0042L44.4838 93.7111C45.4927 93.7713 46.5167 93.8165 47.5407 93.8165C58.3831 93.8165 68.3369 90.0518 76.1976 83.7572L78.1252 85.6847L77.8089 82.3868L76.544 68.9393L62.7953 67.6744Z",
    fill: "url(#paint6_linear_11_255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8301 72.7492L42.6165 70.0838V72.4179C36.8339 71.2584 31.7892 68.096 28.2052 63.6988L27.0005 76.5741L12.785 77.9144C20.1939 86.5129 30.72 92.3256 42.6165 93.5906V96L44.4838 93.7562L53.3534 83.0494L44.8301 72.7492Z",
    fill: "url(#paint7_linear_11_255)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_255",
    x1: 25.2235,
    y1: 74.5412,
    x2: 12.2729,
    y2: 36.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D0536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46021B",
    stopOpacity: 0.91
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_255",
    x1: 12.4988,
    y1: 51.1247,
    x2: 38.1741,
    y2: 14.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8D07",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_255",
    x1: 17.92,
    y1: 25.8259,
    x2: 68.2917,
    y2: 15.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B00751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631705,
    stopColor: "#6B002F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_255",
    x1: 45.7035,
    y1: 12.4235,
    x2: 73.4871,
    y2: 31.0212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F8809",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11_255",
    x1: 69.873,
    y1: 20.7059,
    x2: 82.2212,
    y2: 52.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8400",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11_255",
    x1: 79.3901,
    y1: 42.6315,
    x2: 79.3901,
    y2: 82.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B10014",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11_255",
    x1: 74.6165,
    y1: 70.5506,
    x2: 43.6706,
    y2: 83.8024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C7BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C24A8",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11_255",
    x1: 43.6706,
    y1: 82.8235,
    x2: 20.4047,
    y2: 70.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9900B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 94,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/Process.eb90da6c732fa34032e638f19b0c7a00.svg";
export { ForwardRef as ReactComponent };